module.exports = __webpack_public_path__ + "img/question.7d72014a.svg";